$(document).ready(function () {
    var tagPageImage = $("#tag-page-image");
    if (tagPageImage !== null && tagPageImage !== undefined) {
        tagPageImage.insertBefore(".breadcrumb");
    }

    var tagPageText = $("#tag-page-text");
    if (tagPageText !== null && tagPageText !== undefined) {
        tagPageText.appendTo("#ContentZone").wrap("<div class=\"module module-colorscheme-none\"></div>").wrap("<div class=\"container-fluid\"></div>");
    }
});